import { useEffect } from 'react'
import toast from 'react-hot-toast'
import { LogOut, UserRound } from 'lucide-react'
import { useLocation } from 'react-router-dom'

import { useAuth } from '@/context/AuthContext'
import AppleHealthSettingsCard from '@/components/AppleHealthSettingsCard'
import DoctorAccessManager from '@/components/DoctorAccessManager'

export default function Settings() {
  const { profile, signOut } = useAuth()
  const location = useLocation()

  useEffect(() => {
    if (!location.hash) {
      return
    }

    const target = document.querySelector(location.hash)

    if (target instanceof HTMLElement) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }, [location.hash])

  async function handleSignOut() {
    try {
      await signOut()
      toast.success('Deconnexion reussie')
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Impossible de se deconnecter'
      toast.error(message)
    }
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <span className="h-2.5 w-2.5 rounded-full bg-cyan-400" />
        <h1 className="text-2xl font-bold text-white">Parametres</h1>
      </div>

      <div className="card">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-emerald-500/15 text-emerald-300">
              <UserRound className="h-5 w-5" />
            </div>
            <div>
              <p className="text-sm font-semibold text-white">
                {profile?.full_name?.trim() || 'Camille'}
              </p>
              <p className="text-sm text-slate-400">
                {profile?.email || 'Compte patient'}
              </p>
            </div>
          </div>

          <button className="btn-secondary" type="button" onClick={handleSignOut}>
            <LogOut className="h-4 w-4" />
            Se deconnecter
          </button>
        </div>
      </div>

      <AppleHealthSettingsCard />
      <DoctorAccessManager />
    </div>
  )
}
